import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  fontWeights,
  fontFamilies,
  palette,
  fontSizes,
  breakpoints,
  lineHeights,
}: Theme) => ({
  serviceTitle: {
    fontFamily: fontFamilies.primary,
    fontWeight: fontWeights.medium,
    fontSize: fontSizes.sm,
    lineHeight: lineHeights.md,
    [breakpoints.up('xl')]: {
      '&:nth-of-type(2)': {
        paddingTop: 12,
        marginTop: 20,
        borderTopWidth: '1px',
        borderTopStyle: 'solid',
        borderColor: palette.grey['200'],
      },
    },
  },
  service: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: 0,
    margin: 0,
  },
  serviceItem: {
    listStyle: 'none',
    display: 'block',
    width: 'fit-content',
    padding: '0.5rem 0.75rem',
    marginBottom: 8,
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: palette.grey['400'],
    borderRadius: '2.25rem',
    color: palette.grey['800'],
    fontSize: fontSizes.xs,
    lineHeight: lineHeights.sm,
    [breakpoints.up('sm')]: {
      fontSize: fontSizes.sm,
      lineHeight: lineHeights.md,
    },
    '&:not(:last-child)': {
      marginRight: 8,
    },
    '& .MuiIconButton-root': {
      marginLeft: 6,
    },
  },
}));
